export default __webpack_public_path__ + "static/wtf-a74ede134c17a0b9ce1de3ffc97f2374.jpg";